// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1XOUZ","label":"Radio_label__3M-n8","checkMark":"Radio_checkMark__2csYu","disabled":"Radio_disabled__3DQrO"};